import React from 'react';
import { css } from 'emotion';
import { Caption } from '@root/src/web/components/Caption';
export const SpotifyBlockComponent = ({ embedUrl, width, height, title, format, palette, caption, credit }) => {
    const embedContainer = css `
		iframe {
			width: 100%;
		}
		margin-bottom: 16px;
	`;
    return (React.createElement(React.Fragment, null, embedUrl && title && width && height && (React.createElement("div", { className: embedContainer, "data-cy": "spotify-embed" },
        React.createElement("iframe", { src: embedUrl, title: title, height: height, width: width, allowFullScreen: true }),
        caption && (React.createElement(Caption, { captionText: caption, format: format, palette: palette, credit: credit }))))));
};
